var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{class:_vm.classNames,attrs:{"value":_vm.selectedCountry,"disabled":_vm.disabled,"outlined":"","items":_vm.countries,"item-text":"text","item-value":"value","label":"Country","rules":[(v) => !!v || 'Country is required'],"single-line":""},on:{"input":function($event){return _vm.$emit('update', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }